import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestfulService } from '../rest/restful';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable()
export class FileAssetsService extends RestfulService<Models.FileAsset> {

  constructor(private restService: RestService) {
    super(Models.FileAsset);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('file-assets');
  }

}
